import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { Select } from '../../General/Select';
import {
  FlexCol,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { FormWrapper, FormInput } from '../../Form/FormInput';
import { CheckBox } from '../../General/Checkbox';
import {
  prop,
  getCountryFromId,
  getDeliveryInfoFromAddress,
} from '../../../../utilities';

interface Props {
  onBlur: () => void;
  deliveryAddress: any;
  deliveryAddresses: any;
  formProblems: any;
  handleChange: (data: { field: string; value: string | number }) => {};
}

function DeliveryAddress({
  deliveryAddress,
  onBlur,
  deliveryAddresses,
  formProblems,
  handleChange,
}: Props) {
  const initialState = getInitialState(deliveryAddress);
  const {
    street,
    street_number,
    city,
    zip,
    country,
    name,
    surname,
    phone,
    email,
  } = initialState;
  const isEmptyDeliveryAddress =
    deliveryAddress.city === '' && deliveryAddress.street === '';
  const [deliveryId, setDeliveryId] = React.useState(initialState.deliveryId);
  const [addNewAddress, setAddNewAddress] = React.useState(
    !initialState.deliveryId,
  );
  const [showContactForms, setShowConcactForms] = React.useState(
    isEmptyDeliveryAddress,
  );

  const {
    streetProblem,
    streetNrProblem,
    cityProblem,
    zipProblem,
    nameProblem,
    surnameProblem,
    emailProblem,
    phoneProblem,
  } = {
    streetProblem: prop(formProblems, 'delivery_address.street'),
    streetNrProblem: prop(formProblems, 'delivery_address.street_number'),
    cityProblem: prop(formProblems, 'delivery_address.city'),
    zipProblem: prop(formProblems, 'delivery_address.zip'),
    nameProblem: prop(formProblems, 'delivery_address.person.name'),
    surnameProblem: prop(formProblems, 'delivery_address.person.surname'),
    emailProblem: prop(formProblems, 'delivery_address.person.email'),
    phoneProblem: prop(formProblems, 'delivery_address.person.phone'),
  };

  const onChange = event => {
    handleChange({ field: event.target.name, value: event.target.value });
  };

  const handleAddressChange = e => {
    const newId = e.target.value;

    if (newId && +newId !== 0) {
      setShowConcactForms(false);
    } else {
      setShowConcactForms(true);
    }

    if (+newId !== +initialState.deliveryId) {
      setDeliveryId(newId);
      handleChange({
        field: 'delivery_address.delivery_address_id',
        value: +newId,
      });

      const info = getDeliveryInfoFromAddress(newId, deliveryAddresses);
      if (info) {
        const {
          delivery_street,
          delivery_number,
          delivery_city,
          delivery_zip,
          delivery_phone,
          country: deliveryCountry,
          name: delName,
          surname: delSurname,
          delivery_email,
        } = info;
        handleChange({
          field: 'delivery_address.street',
          value: delivery_street,
        });
        handleChange({
          field: 'delivery_address.street_number',
          value: delivery_number,
        });
        handleChange({ field: 'delivery_address.city', value: delivery_city });
        handleChange({ field: 'delivery_address.zip', value: delivery_zip });
        handleChange({
          field: 'delivery_address.country',
          value: deliveryCountry,
        });
        handleChange({
          field: 'delivery_address.person.name',
          value: delName || '',
        });
        handleChange({
          field: 'delivery_address.person.surname',
          value: delSurname || '',
        });
        handleChange({
          field: 'delivery_address.person.phone',
          value: delivery_phone || '',
        });
        handleChange({
          field: 'delivery_address.person.email',
          value: delivery_email || '',
        });

        // small delay yo ensure saving data to API
        setTimeout(() => {
          onBlur();
        }, 300);
      }
    }
  };

  // const handleNewAddressClick = e => {
  //   setAddNewAddress(e.target.value);
  //   if (e.target.value) {
  //     handleChange({
  //       field: 'delivery_address.delivery_address_id',
  //       value: 0,
  //     });
  //   }
  // };

  const remappedAddresses = deliveryAddresses
    ? [
        { value: 0, name: __('Zvoliť dodaciu adresu') },
        ...deliveryAddresses.map(d => ({
          value: d.id,
          name: `${d.delivery_street} ${d.delivery_number}, ${
            d.delivery_city
          } ${d.delivery_zip}, ${getCountryFromId(d.country)}`,
        })),
      ]
    : null;

  return (
    <Wrapper>
      {remappedAddresses && remappedAddresses.length > 1 && (
        <PastDeliveryAdrressesWrapper>
          <Select
            placeholder={__('Vyberte zo zoznamu')}
            marginBottom={32}
            name="addresses"
            label={__('Moje adresy')}
            value={deliveryId}
            options={remappedAddresses}
            onChange={handleAddressChange}
          />

          {/*<CheckBox*/}
          {/*  name="addNewAddress"*/}
          {/*  onClick={handleNewAddressClick}*/}
          {/*  selected={addNewAddress}*/}
          {/*  label={__('Pridať novú adresu')}*/}
          {/*/>*/}
        </PastDeliveryAdrressesWrapper>
      )}

      <>
        <AddressWrapper>
          <FormWrapper noWrap={false} maxWidth={800} marginRight={0.5}>
            <FormInput
              name="delivery_address.person.name"
              type="text"
              label={__('Meno')}
              value={name}
              maxWidthPx={320}
              marginRight={16}
              onChange={onChange}
              marginBottom={16}
              onBlur={onBlur}
              validMessage={nameProblem}
              required={true}
            />
            <FormInput
              name="delivery_address.person.surname"
              type="text"
              label={__('Priezvisko')}
              value={surname}
              maxWidthPx={320}
              marginRight={16}
              onChange={onChange}
              marginBottom={16}
              onBlur={onBlur}
              validMessage={surnameProblem}
            />
          </FormWrapper>
          <FormWrapper noWrap={false} maxWidth={800} marginRight={0.5}>
            <FormInput
              name="delivery_address.street"
              type="text"
              label={__('Ulica')}
              value={street}
              maxWidth={100}
              maxWidthPx={224}
              marginRight={16}
              onChange={onChange}
              marginBottom={16}
              onBlur={onBlur}
              validMessage={streetProblem}
              required={true}
            />
            <FormInput
              name="delivery_address.street_number"
              type="text"
              label={__('Číslo')}
              value={street_number}
              maxWidth={34}
              maxWidthPx={80}
              marginRight={16}
              onChange={onChange}
              marginBottom={16}
              onBlur={onBlur}
              validMessage={streetNrProblem}
              required={true}
            />
            <FormInput
              name="delivery_address.city"
              type="text"
              label={__('Mesto')}
              value={city}
              maxWidth={100}
              maxWidthPx={224}
              marginRight={16}
              onChange={onChange}
              marginBottom={16}
              onBlur={onBlur}
              validMessage={cityProblem}
              required={true}
            />
            <FormInput
              name="delivery_address.zip"
              type="text"
              label={__('PSČ')}
              value={zip}
              maxWidth={34}
              maxWidthPx={80}
              onChange={onChange}
              marginBottom={16}
              onBlur={onBlur}
              validMessage={zipProblem}
              required={true}
            />
          </FormWrapper>
          {showContactForms && (
            <FormWrapper noWrap={false} maxWidth={800} marginRight={0.5}>
              <FormInput
                name="delivery_address.person.email"
                type="email"
                label={__('Email')}
                value={email}
                maxWidthPx={320}
                marginRight={16}
                onChange={onChange}
                marginBottom={16}
                onBlur={onBlur}
                validMessage={emailProblem}
                required={true}
              />
              <FormInput
                name="delivery_address.person.phone"
                type="text"
                label={__('Telefón')}
                value={phone}
                maxWidthPx={320}
                marginRight={16}
                onChange={onChange}
                marginBottom={16}
                onBlur={onBlur}
                validMessage={phoneProblem}
                required={true}
              />
            </FormWrapper>
          )}
        </AddressWrapper>

        <Select
          marginBottom={0}
          name="delivery_address.country"
          label={__('Krajina')}
          value={country}
          options={[{ value: 'sk', name: 'Slovensko' }]}
          onChange={onChange}
          onBlur={onBlur}
          required={true}
        />
      </>
    </Wrapper>
  );
}

const getInitialState = (deliveryAddress: any) => {
  return {
    street: prop(deliveryAddress, 'street', ''),
    street_number: prop(deliveryAddress, 'street_number', ''),
    city: prop(deliveryAddress, 'city', ''),
    zip: prop(deliveryAddress, 'zip', ''),
    country: prop(deliveryAddress, 'country', 'sk') || 'sk',
    deliveryId: prop(deliveryAddress, 'delivery_address_id', ''),
    name: prop(deliveryAddress, 'person.name', ''),
    surname: prop(deliveryAddress, 'person.surname', ''),
    phone: prop(deliveryAddress, 'person.phone', ''),
    email: prop(deliveryAddress, 'person.email', ''),
  };
};

const Wrapper = styled(FlexCol)``;

const AddressWrapper = styled(FlexRowCenterVertical)`
  flex-flow: row wrap;
`;

const PastDeliveryAdrressesWrapper = styled(FlexCol)`
  margin-bottom: ${rem(32)};
`;

export { DeliveryAddress };
